import React, {FC} from "react"
import {useTranslation} from "next-i18next"
import Button from "../../reusable/components/Button"
import {X} from "react-bootstrap-icons"
import Typography from "../../reusable/Typography/Typography"
import PropTypes from "prop-types"

type Props = {
	activeFilters: { key: string, activeItems: any[] }[],
	titleString?: string,
	removeFilterByParamKey: (name: string, value: string) => void,
	removeAllFilters: () => void,
	showButtonOnly?: boolean
}

const SelectedFiltersMobile: FC<Props> = ({
	activeFilters,
	titleString,
	removeFilterByParamKey,
	removeAllFilters,
	showButtonOnly = false
}): React.ReactElement => {
	const {t} = useTranslation(["filters"])

	const totalActiveItems = activeFilters?.reduce((sum, item) => {
		return sum + (Array.isArray(item.activeItems) ? item.activeItems.length : 0)
	}, 0)

	return (
		<div className={showButtonOnly ? "" : "row"}>

			{showButtonOnly === false ?
				<>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<Typography variant="bodyLgBold"
							semanticTag="span">{titleString}</Typography>
					</div>
					<ul className="list-unstyled m-0">
						{activeFilters.map(({key, activeItems}) => {
							return activeItems.map(item => <li onClick={removeAllFilters}
								key={item.id}
								className="mb-2">
								<span className="me-2">
									<X size={25}/>
								</span>
								<Typography className="me-2"
									variant="bodyLgBold"
									semanticTag="span">
									{`${key}:`}
								</Typography>
								<Typography variant="bodyLg"
									semanticTag="span">
									{item.name}
								</Typography>
							</li>
							)
						})}
					</ul>
				</> : null}
			{totalActiveItems ?
				<Button onClick={removeAllFilters}
					fontSizeSmall
					className="col-12 my-3"
					label={`${t("resetFilters", {ns: "filters"})} (${totalActiveItems})`}
					textColor="#212529"
					bgColor="#fff"
					hoverColor="#212529"
					outline/> : null}
		</div>
	)
}

SelectedFiltersMobile.propTypes = {
	activeFilters: PropTypes.array,
	titleString: PropTypes.string,
	removeFilterByParamKey: PropTypes.func,
	removeAllFilters: PropTypes.func
}

export default SelectedFiltersMobile
